export default "__VITE_ASSET__5aad1961__"